export const CREDIT_ROOT_ROUTE = '/credit-app';

export const DEFAULT_SPONSOR = 'ddc';

export const MessagesTypes = {
    CONFIRMATION_PAGE: 'CONFIRMATION_PAGE',
    ERROR: 'ERROR',
    INIT: 'INIT'
};

export const routes = {
    CREDIT_APP_ROOT: CREDIT_ROOT_ROUTE
};

export const getAllRoutes = () => Object.values(routes);

export const CREDIT_APP_MODE = 'STANDALONE';
export const CREDIT_APP_SOURCE_ID = 'CREDIT_APP';
